// extracted by mini-css-extract-plugin
export var container = "_6c-0";
export var infoButton = "_6c-1";
export var label = "_6c-3";
export var labelExpanded = "_6c-4";
export var price = "_6c-5";
export var priceExpanded = "_6c-6";
export var title = "_6c-2";